
(function(){
  var fr=(document.documentElement.lang||'').toLowerCase().indexOf('fr')===0;
  function q(s,r){return (r||document).querySelector(s)}
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function txt(el,v){if(el&&v&&el.textContent.trim()!==v)el.textContent=v}
  function routeLabels(){
    qa('[data-route="today"] span').forEach(function(e){txt(e,fr?'Accueil':'Home')});
    qa('[data-route="purchases"] span').forEach(function(e){txt(e,fr?'Mes achats':'Purchases')});
    qa('[data-route="actions"] span').forEach(function(e){txt(e,fr?'À faire':'To do')});
    qa('[data-route="account"] span').forEach(function(e){txt(e,fr?'Compte':'Account')});
    qa('[data-route="recovery"] span').forEach(function(e){txt(e,fr?'Remboursements':'Recoveries')});
  }
  function marketing(){
    if(!document.body.classList.contains('pg-template-index'))return;
    var root=q('.asx');if(!root)return;
    /* Native landing header/sidebar retained. */

    /* Landing copy is owned by the Liquid section and respects the selected locale. */
  }
  function appCopy(){
    var app=q('[data-aftersentry-native-app]');if(!app)return;
    routeLabels();if(!fr)return;
    var top=q('#top-title');if(top&&top.textContent.trim()==='Actions')txt(top,'À faire');if(top&&top.textContent.trim()==='Recovery')txt(top,'Remboursements');
    txt(q('#view-today .status-kicker span:last-child'),'Surveillance active');
    var homeH=qa('#view-today .card-h h3');if(homeH[0])txt(homeH[0],'À faire');
    var av=q('#view-actions');if(av){txt(q('.eyebrow',av),'À faire');txt(q('.hero h2',av),'Ce qui demande votre attention.');txt(q('.hero p',av),'Chaque carte vous indique pourquoi agir, ce qui est en jeu et la prochaine étape utile.');txt(q('.card-h h3',av),'Vos actions')}
    var pv=q('#view-purchases');if(pv){txt(q('.hero h2',pv),'Tous vos achats, au même endroit.');txt(q('.hero p',pv),'Ouvrez un achat pour voir ses documents, ses échéances et les éventuelles actions à effectuer.')}
    var ac=q('#view-account');if(ac){txt(q('.hero h2',ac),'Votre compte et vos connexions.');txt(q('.hero p',ac),'Gérez ici votre messagerie, votre abonnement, vos données et les réglages avancés.')}
    var sv=q('#view-sources');if(sv){txt(q('.hero h2',sv),'Connectez votre messagerie.');txt(q('.hero p',sv),'AfterSentry retrouve ensuite automatiquement les achats qu’il peut identifier.')}
    var rv=q('#view-recovery');if(rv){txt(q('.eyebrow',rv),'Remboursements');txt(q('.hero h2',rv),'Suivez vos remboursements jusqu’au résultat.');txt(q('.hero p',rv),'AfterSentry garde le dossier, les preuves et la prochaine action au même endroit.')}
    txt(q('#onboarding-dialog .modal-h h3'),'Connectez votre messagerie. AfterSentry fait le reste.');
    txt(q('#global-search-dialog .modal-h h3'),'Rechercher dans vos achats et documents');
    txt(q('#paywall-title'),'Activez le suivi continu avec Guard+');
  }
  function advanced(){
    var grid=q('.account-sections');if(!grid||grid.getAttribute('data-as-simple')==='1')return;
    grid.setAttribute('data-as-simple','1');var cards=qa(':scope > .card',grid);if(cards.length<=3)return;
    cards.slice(3).forEach(function(c){c.classList.add('as-advanced')});
    var b=document.createElement('button');b.type='button';b.className='btn secondary as-advanced-toggle';b.setAttribute('aria-expanded','false');b.textContent=fr?'Afficher les réglages avancés':'Show advanced settings';
    b.addEventListener('click',function(){var open=grid.classList.toggle('as-open-advanced');b.setAttribute('aria-expanded',String(open));b.textContent=open?(fr?'Masquer les réglages avancés':'Hide advanced settings'):(fr?'Afficher les réglages avancés':'Show advanced settings')});
    grid.appendChild(b);
  }
  function cookies(){
    if(!fr)return;var b=q('.as-cookie__banner');if(!b)return;
    txt(q('h2',b),'Vos préférences de confidentialité');txt(q('p',b),'Les cookies nécessaires sont toujours actifs. Les autres ne le sont qu’avec votre accord.');
    txt(q('[data-as-cookie-reject]',b),'Refuser');txt(q('[data-as-cookie-custom]',b),'Choisir');txt(q('[data-as-cookie-accept]',b),'Accepter');
  }
  function apply(){marketing();appCopy();advanced();cookies()}
  function start(){apply();var app=q('[data-aftersentry-native-app]');if(!app)return;var busy=false;new MutationObserver(function(){if(busy)return;busy=true;requestAnimationFrame(function(){busy=false;appCopy()})}).observe(app,{subtree:true,childList:true,characterData:true})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

(function(){
  function syncLandingSidebar(){
    if(!document.body.classList.contains('pg-template-index')) return;
    var sidebar=document.getElementById('asx-sitebar');
    if(!sidebar) return;
    var desktop=window.matchMedia('(min-width:981px)').matches;
    if(desktop){
      sidebar.setAttribute('aria-hidden','false');
      document.querySelectorAll('[data-asx-sidebar-open]').forEach(function(b){b.setAttribute('aria-expanded','true')});
    }else if(!sidebar.classList.contains('is-open')){
      sidebar.setAttribute('aria-hidden','true');
      document.querySelectorAll('[data-asx-sidebar-open]').forEach(function(b){b.setAttribute('aria-expanded','false')});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',syncLandingSidebar,{once:true}); else syncLandingSidebar();
  window.addEventListener('resize',syncLandingSidebar,{passive:true});
})();

